import ProfileMenu from '@/agilis/components/ProfileMenu/ProfileMenu'

export default {
  name: 'ProfileMenuMobile',
  mixins: [ProfileMenu]
}
